// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup_wrapper {
    box-sizing: border-box;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    overflow: auto;
    outline: 0;
}

.popup_content {
    box-sizing: border-box;
    position: relative;
    border: 1px solid darkgray;
    /* min-width: 240px; */
    /* max-width: 600px; */
    top: 50%;
    transform: translateY(-50%);
    margin: 0 auto;
    background-color: white;
    /* box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.3); */

    width: 240px;
    height: Hug (150px)px;
    padding: 20px;
    gap: 20px;
    border-radius: 8px;
    border: solid 1px #CCCCCC;


}

.popup_title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;
    font-family: Pretendard;
    font-size: 16px;
    font-weight: 700;
    line-height: 26px;
}
.popup_message {
    margin-top: 15px;
    white-space:pre-wrap;
    text-align: center;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    text-align: center;
}
.popup_button_layer {
    display: flex;
    margin-top: 20px;
    justify-content: center;
    align-items: center;
    gap: 8px;
}
.popup_button {
    height: 30px;
    border: 0px;
    border-radius: 4px;
    text-align: center;
    font-family: Pretendard;
    font-size: 14px;
    flex: 1 1;
}

.popup_confirm {
    background: #426AE6;
    font-weight: 600;
    color: white;
}

.popup_cancel {
    background: #ECEEED;
    font-weight: 400;
    color: black;
}
`, "",{"version":3,"sources":["webpack://./src/popup/popup.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,cAAc;IACd,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,sBAAsB;IACtB,sBAAsB;IACtB,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,uBAAuB;IACvB,kDAAkD;;IAElD,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,yBAAyB;;;AAG7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":[".popup_wrapper {\r\n    box-sizing: border-box;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 1000;\r\n    overflow: auto;\r\n    outline: 0;\r\n}\r\n\r\n.popup_content {\r\n    box-sizing: border-box;\r\n    position: relative;\r\n    border: 1px solid darkgray;\r\n    /* min-width: 240px; */\r\n    /* max-width: 600px; */\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    margin: 0 auto;\r\n    background-color: white;\r\n    /* box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.3); */\r\n\r\n    width: 240px;\r\n    height: Hug (150px)px;\r\n    padding: 20px;\r\n    gap: 20px;\r\n    border-radius: 8px;\r\n    border: solid 1px #CCCCCC;\r\n\r\n\r\n}\r\n\r\n.popup_title {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 5px;\r\n    font-family: Pretendard;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    line-height: 26px;\r\n}\r\n.popup_message {\r\n    margin-top: 15px;\r\n    white-space:pre-wrap;\r\n    text-align: center;\r\n    font-family: Pretendard;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    line-height: 26px;\r\n    text-align: center;\r\n}\r\n.popup_button_layer {\r\n    display: flex;\r\n    margin-top: 20px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n.popup_button {\r\n    height: 30px;\r\n    border: 0px;\r\n    border-radius: 4px;\r\n    text-align: center;\r\n    font-family: Pretendard;\r\n    font-size: 14px;\r\n    flex: 1;\r\n}\r\n\r\n.popup_confirm {\r\n    background: #426AE6;\r\n    font-weight: 600;\r\n    color: white;\r\n}\r\n\r\n.popup_cancel {\r\n    background: #ECEEED;\r\n    font-weight: 400;\r\n    color: black;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
